import React from "react";
import { Link } from "react-router-dom";

/**
 * @author
 * @function GetStarted
 **/

export const GetStarted = (props) => {
  return (
    <section className="flex justify-center items-center mt-16">
      <Link
        to={"/dealer-info/subcription-plan"}
        className="px-8 py-3 rounded-lg text-[24px] text-secondary font-bold bg-white hover:bg-secondary hover:text-white border border-2 border-[#292929]"
      >
        Get Started – Join the Network
      </Link>
    </section>
  );
};
